<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{pageData.MenuName}}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>服務機關：</td>
                  <td colspan="3">
                    <select
                      v-model="form.govCode1"
                      style="min-width: 200px"
                      @change="GovCode1Change()"
                      disabled
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode2"
                      style="min-width: 200px"
                      @change="GovCode2Change()"
                      disabled
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode3"
                      style="min-width: 200px"
                      @change="GovCode3Change()"
                      disabled
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode4"
                      style="min-width: 200px"
                      disabled
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>姓名：</td>
                  <td><input type="text" v-model="form.name" /></td>
                  <td>身分證統一編號：</td>
                  <td>
                    <input type="text" disabled="disabled" v-model="form.idn" />
                  </td>
                </tr>
                <tr>
                  <td>職稱：</td>
                  <td><input type="text" v-model="form.title" /></td>
                  <td>階級：</td>
                  <td>
                    <select v-model="form.rank">
                      <option value="">無</option>
                      <option value="1">上將</option>
                      <option value="2">中將</option>
                      <option value="3">少將</option>
                      <option value="4">上校</option>
                      <option value="5">中校</option>
                      <option value="6">少校</option>
                      <option value="7">上尉</option>
                      <option value="8">中尉</option>
                      <option value="9">少尉</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>聯絡電話：</td>
                  <td>
                    <input type="text" v-model="form.tel" />
                  </td>
                  <td>E-Mail：</td>
                  <td>
                    <input
                      type="text"
                      class="input"
                      title="請輸入有效且能正常收信之EMAIL"
                      Placeholder="請確認為有效且能正常收信之EMAIL"
                      v-model="form.email"
                      size="40"
                      maxlength="40"
                    />
                  </td>
                </tr>
                <tr>
                  <td>到職日期：</td>
                  <td>
                    <DatePicker
                      v-model="form.arrive_date"
                      format="YYYMMDD"
                      :isTaiwanYear="true"
                      clearable
                      placeholder="請輸入/選擇日期"
                    /><br />
                  </td>
                  <td>現職狀況：</td>
                  <td>
                    <select disabled="disabled" v-model="form.now_st">
                      <option value="1">在職</option>
                      <option value="2">離職</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td style="width: 150px">備註：</td>
                  <td colspan="3">
                    <p>
                      <textarea
                        title="最多輸入5百個字"
                        Placeholder="最多輸入5百個字"
                        cols="100"
                        rows="5"
                        v-model="form.note"
                      ></textarea>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="4" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="存檔"
                          @click="btnSave()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import { getMenuIndex,getMenu, logOut } from "@/config/util.js";
import { SearchGovCode, S301_Query, S301_Modify } from "@/service/api.js";
import PdisFooter from "@/components/Common/PdisFooter.vue";
export default {
  name: "S301",
  data: function () {
    return {
      pageData: {
        MenuIndex: 6,
        MenuName: "",
        PrgName: "S301",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      form: {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "0",
        idn: "",
        name: "",
        title: "",
        rank: "",
        tel: "",
        email: "",
        arrive_date: "",
        now_st: "",
        note: "",
        jobstatus: "",
      },
      dropDownList: {
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    Alert: VueModal,
    PdisFooter,
    DatePicker: VueDatepicker,
  },
  methods: {
    //取得服務機關第一層類別
    getSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得服務機關第二層類別
    getSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得服務機關第三層類別
    getSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得服務機關第四層類別
    getSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //查詢
    doQuery: function () {
      const self = this;
      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        ID: self.loginInfo.id,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S301_Query(postData).then((rData) => {
        if(rData.result){
          self.form.govCheck = "0";
          self.form.idn = rData.returnObject.idn;
          self.form.name = rData.returnObject.name;
          self.form.title = rData.returnObject.title;
          self.form.rank = rData.returnObject.rank;
          self.form.tel = rData.returnObject.tel;
          self.form.email = rData.returnObject.email;
          self.form.arrive_date = rData.returnObject.arrivE_DATE
            ? self.$moment(rData.returnObject.arrivE_DATE)._d
            : "";
          self.form.now_st = rData.returnObject.noW_ST;
          self.form.note = rData.returnObject.note;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //存檔
    btnSave: function () {
      const self = this;
      let errorMsg = [];
      if (self.form.name.trim() == "") {
        errorMsg.push("請填寫姓名");
      }
      if (self.form.title.trim() == "") {
        errorMsg.push("請填寫職稱");
      }
      if (self.form.tel.trim() == "") {
        errorMsg.push("請填寫聯絡電話");
      }
      if (self.form.tel.trim() == "") {
        errorMsg.push("請填寫聯絡電話");
      }
      if (self.form.email.trim() == "") {
        errorMsg.push("請填寫E-Mail");
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }

      let postData = {
        ServiceUnit: self.pageData.ServiceUnit,
        ID: self.loginInfo.id,
        NAME: self.form.name,
        TITLE: self.form.title,
        RANK: self.form.rank,
        TEL: self.form.tel,
        EMAIL: self.form.email,
        ARRIVE_DATE: self.form.arrive_date ? self.form.arrive_date : null,
        NOW_ST: self.form.now_st,
        NOTE: self.form.note,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "存檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      S301_Modify(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["存檔成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.form.Selected = [];
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["存檔失敗"];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    GovCodeInit: function (form){
      const self = this;
      if(self.loginInfo){
        let govCodeArray = self.loginInfo.govCodeStr.split(',');
        form.govCode1 = govCodeArray[0];
        form.govCode2 = govCodeArray[1];
        form.govCode3 = govCodeArray[2];
        form.govCode4 = govCodeArray[3];
      }
    },
    GovCode1Change: function(){
      const self = this;
      self.form.govCode2 = "";
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode2s = [];
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode2Change: function(){
      const self = this;
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode3Change: function(){
      const self = this;
      self.form.govCode4 = "";
      self.dropDownList.govCode4s = [];
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if(Menu){
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.doQuery();
    self.GovCodeInit(self.form);
    self.getSearchGovCode1();
  },
  watch: {
    "form.govCode1": function (newValue, oldValue) {
      if(newValue != '') this.getSearchGovCode2(newValue);
    },
    "form.govCode2": function (newValue, oldValue) {
      if(newValue != '') this.getSearchGovCode3(newValue);
    },
    "form.govCode3": function (newValue, oldValue) {
      if(newValue != '') this.getSearchGovCode4(newValue);
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
